export const organizationInfoFragment = `
id
slug
name
image
businessType
publicPageImage
`;
